import React, { useState,useEffect} from 'react';
import Header from '../common/layout/header'; 
import Footer from '../common/layout/footer'; 
import { http } from '../helper';
import ShowAlert from '../common/Showalert';
import { BaseUrl } from '../common/config';
import CommonAlert from '../common/Commonalert';
import Sidebar from '../common/sidebar';
import { menuPermissions } from '../account/menupermissions';

const AddRoles = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datalist, setDataList] = useState([]);
  const [roleName, setRoleName] = useState('');
  const [selectedPermissions, setSelectedPermissions] = useState([]); // module-level strings e.g. manage_products
  const [selectedSubPermissions, setSelectedSubPermissions] = useState({}); // { manage_products: ['manage_products.view', ...] }
  const [errors, setErrors] = useState({});
  const [alertMessage, setAlertMessage] = useState([]);
  const [alertPopup, setAlertPopup] = useState(false);
  const [alerterrorPopup, setAlertErrorPopup] = useState(false);
  const [alerterrMessage, setAlerterrMessage] = useState([]);

  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = '/';
  }

  useEffect(()=>{
    fetchData(); 
},[])

  const fetchData = async () => {
    setIsLoading(true);
    try {
    var loginDetails = {};
    if (sessionStorage.getItem('authData')) {
        loginDetails = JSON.parse(sessionStorage.getItem('authData'));
    }
      let URL = BaseUrl + `admin/getRoles`;
      const response = await http.get(URL);
      let responseData = response.data.data;
      if (response.data.success === true) {
        setDataList(responseData || []);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  // helpers
  const getDefaultSubPerms = (moduleValue) => {
    const mod = menuPermissions.find(m => m.value === moduleValue);
    if (!mod || !mod.subPermissions) return [];
    return mod.subPermissions.filter(s => s.default).map(s => s.value);
  };

  const toggleModule = (moduleValue, checked) => {
    if (checked) {
      setSelectedPermissions(prev => Array.from(new Set([...prev, moduleValue])));
      setSelectedSubPermissions(prev => {
        // if there was prior selection keep it, else use defaults
        const prevArr = prev[moduleValue];
        if (prevArr && prevArr.length) return { ...prev };
        return { ...prev, [moduleValue]: getDefaultSubPerms(moduleValue) };
      });
      setErrors(prev => ({ ...prev, permissions: '' }));
    } else {
      setSelectedPermissions(prev => prev.filter(p => p !== moduleValue));
      setSelectedSubPermissions(prev => {
        const copy = { ...prev };
        delete copy[moduleValue];
        return copy;
      });
    }
  };

  const toggleSubPermission = (moduleValue, subValue, checked) => {
    setSelectedSubPermissions(prev => {
      const curr = new Set(prev[moduleValue] || []);
      if (checked) curr.add(subValue); else curr.delete(subValue);
      return { ...prev, [moduleValue]: Array.from(curr) };
    });
    setErrors(prev => ({ ...prev, permissions: '' }));
  };

  const formvalidation = () => {
    const newErrors = {};
    let isValid = true;

    if (roleName.trim() === '') {
      newErrors.roleName = "This field is Required";
      isValid = false;
    }
    if (selectedPermissions.length === 0) {
      newErrors.permissions = "At least one permission must be selected";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const btnsubmit = async (e) => {
    e.preventDefault();
    if (!formvalidation()) return;

    // build permissions payload: module-level + selected sub permissions
    let permissions = [];
    selectedPermissions.forEach(mod => {
      permissions.push(mod);
      const subs = selectedSubPermissions[mod] || [];
      permissions = permissions.concat(subs);
    });
    // deduplicate
    permissions = Array.from(new Set(permissions));

    const payload = {
      roleName: roleName,
      permissions
    };

    // client side duplicate roleName check (case-insensitive)
    const isFound = datalist.some(element => (
      element.roleName && element.roleName.toLowerCase() === roleName.toLowerCase()
    ));

    if (isFound) {
      setAlertErrorPopup(true);
      setAlerterrMessage(`This Role Name has already been added`);
      return;
    }

    try {
      setIsLoading(true);
      const URL = BaseUrl + "admin/addRole/";
      const response = await http.post(URL, payload);
      if (response.data.success === true) {
        setAlertPopup(true);
        setAlertMessage(`Role and Permissions have been added successfully!`);
        // Reset form
        setRoleName('');
        setSelectedPermissions([]);
        setSelectedSubPermissions({});
        // refresh role list
        fetchData();
      } else {
        setAlertErrorPopup(true);
        setAlerterrMessage(response.data.message || 'Failed to add role');
      }
    } catch (err) {
      console.log(err);
      setAlertErrorPopup(true);
      setAlerterrMessage('Server error while adding role');
    } finally {
      setIsLoading(false);
    }
  };

  const routeChange = () => {
    window.location.href = `/role/`;
  }

  return (
    <section className="dashboard-block">
      { alerterrorPopup && ( <ShowAlert title='Alert' message={alerterrMessage}/> ) }
      { alertPopup && ( <CommonAlert title='Alert' message={alertMessage}/> ) }

      <Sidebar />
      <div className="dash-left">
        <Header/>
        <section className="cart-block">
          <div className="container account-details">
            <h1 className="checkout-title">Add Role</h1>
            <div className="right-table-outer-wrap">
              <div className='form-field freeproduct-fieldset addroles-fieldset form-container-xs'>
                <form className='client-detail-form' onSubmit={btnsubmit}>
                  <div className='input-field'>
                    <label htmlFor='name'>Role Name</label>
                    <input
                      type='text'
                      name='roleName'
                      value={roleName}
                      onChange={(e) => {
                        setRoleName(e.target.value);
                        setErrors((prev) => ({ ...prev, roleName: '' }));
                      }}
                    />
                    {errors.roleName && <div className="error-msg">{errors.roleName}</div>}
                  </div>

                  <div className='input-field'>
                    <label>Permissions</label>
                    <div className='custom_check-box'>
                      {menuPermissions.map((module, index) => {
                        const modVal = module.value;
                        const moduleChecked = selectedPermissions.includes(modVal);
                        const subSelected = selectedSubPermissions[modVal] || [];
                        return (
                          <div className='check-box' key={modVal}>
                            <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                              <input
                                id={`chkbox${index}`}
                                type="checkbox"
                                value={modVal}
                                checked={moduleChecked}
                                onChange={(e) => toggleModule(modVal, e.target.checked)}
                              />
                              <label htmlFor={`chkbox${index}`}>{module.name}</label>
                            </div>

                            {/* show sub toggles when module checked */}
                            {moduleChecked && module.subPermissions && (
                              <div className='rolls-action-bx' style={{marginTop: '8px'}}>
                                <div className="switch-group" style={{display:'flex', gap:'12px', flexWrap:'wrap'}}>
                                  {module.subPermissions.map((sub, sidx) => {
                                    const subChecked = subSelected.includes(sub.value);
                                    const isViewToggle = ["view", "refresh"].includes(sub.name.toLowerCase()); 
                                    return (
                                      <div className="switch-item" key={sub.value} style={{display:'flex',alignItems:'center',gap:'6px'}}>
                                        <span className="switch-label">{sub.name}</span>
                                        <label className="switch switch-ios">
                                          <input
                                            type="checkbox"
                                            checked={subChecked}
                                            disabled={isViewToggle}
                                            onChange={(e) => {
                                              if (!isViewToggle) {
                                                toggleSubPermission(modVal, sub.value, e.target.checked);
                                              }
                                            }}
                                          />
                                          <span className="slider-ios"></span>
                                        </label>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                    {errors.permissions && <div className="error-msg">{errors.permissions}</div>}
                  </div>

                  <div className='btnfield' style={{marginTop:'16px'}}>
                    <button type="submit" name="btnsubmit" disabled={isLoading}>Add Role</button>
                    &nbsp;&nbsp;&nbsp;
                    <button type="button" onClick={routeChange}>Cancel</button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <Footer/>
        </section>
      </div>
    </section>
  );
};

export default AddRoles;
